import React, { useState, useEffect } from 'react';
import { EVENTS } from '../utilities/CONSTANTS';

const useUsers = () => {
    const [users, setUsers] = useState();

    useEffect(() => {
        const handleUsersChange = () => setUsers(window._referencableTettraUsers);
        if (!window._referencableTettraUsers) {
            window.addEventListener(EVENTS.USERS_LOADED, handleUsersChange);
        } else {
            setUsers(window._referencableTettraUsers);
        }
        return () => window.removeEventListener(EVENTS.USERS_LOADED, handleUsersChange);
    }, []);

    return users;
};

export default useUsers;
